/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListFineTuningEventsRequest = {
  fineTuningJobId: string;
  after?: string | null | undefined;
  limit?: number | undefined;
};

/** @internal */
export const ListFineTuningEventsRequest$inboundSchema: z.ZodType<
  ListFineTuningEventsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  fine_tuning_job_id: z.string(),
  after: z.nullable(z.string()).optional(),
  limit: z.number().int().default(20),
}).transform((v) => {
  return remap$(v, {
    "fine_tuning_job_id": "fineTuningJobId",
  });
});
/** @internal */
export type ListFineTuningEventsRequest$Outbound = {
  fine_tuning_job_id: string;
  after?: string | null | undefined;
  limit: number;
};

/** @internal */
export const ListFineTuningEventsRequest$outboundSchema: z.ZodType<
  ListFineTuningEventsRequest$Outbound,
  z.ZodTypeDef,
  ListFineTuningEventsRequest
> = z.object({
  fineTuningJobId: z.string(),
  after: z.nullable(z.string()).optional(),
  limit: z.number().int().default(20),
}).transform((v) => {
  return remap$(v, {
    fineTuningJobId: "fine_tuning_job_id",
  });
});

export function listFineTuningEventsRequestToJSON(
  listFineTuningEventsRequest: ListFineTuningEventsRequest,
): string {
  return JSON.stringify(
    ListFineTuningEventsRequest$outboundSchema.parse(
      listFineTuningEventsRequest,
    ),
  );
}
export function listFineTuningEventsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListFineTuningEventsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListFineTuningEventsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListFineTuningEventsRequest' from JSON`,
  );
}
